import type { Operation } from '@vigilo/shared';

function venueOperationStatusPriority(status: Operation['status']): number {
  if (status === 'active' || status === 'paused') return 0;
  if (status === 'scheduled') return 1;
  return 2;
}

export function sortVenueOperationsForHistory(operations: Operation[]): Operation[] {
  return [...operations].sort((a, b) => {
    const priorityDelta = venueOperationStatusPriority(a.status) - venueOperationStatusPriority(b.status);
    if (priorityDelta !== 0) return priorityDelta;

    if (venueOperationStatusPriority(a.status) === 1) {
      return new Date(a.scheduledStart).getTime() - new Date(b.scheduledStart).getTime();
    }

    return new Date(b.scheduledStart).getTime() - new Date(a.scheduledStart).getTime();
  });
}
